import { render, staticRenderFns } from "./GroupSelectWidget.vue?vue&type=template&id=cf9cfce6&scoped=true&"
import script from "./GroupSelectWidget.vue?vue&type=script&lang=js&"
export * from "./GroupSelectWidget.vue?vue&type=script&lang=js&"
import style0 from "./GroupSelectWidget.vue?vue&type=style&index=0&id=cf9cfce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9cfce6",
  null
  
)

export default component.exports